export default {
  Object: 'Đối tượng',
  FullName: 'Họ tên',
  Address: 'Địa chỉ',
  Explain: 'Diễn giải',
  CTDate: 'Ngày CT',
  HTDate: 'Ngày HT',
  VoucherNumber: 'Số CT',
  SalaryAccounting: 'Hạch toán chi phí lương, BH, KPCĐ',
  InsuaranceAccounting: 'Hạch toán chi phí bảo hiểm',
  SummaryAmount: 'Tổng tiền',
  CommonInfo: 'Thông tin chung',
  Description: 'Rút dự toán trả lương sinh từ Hạch toán chi phí lương, bảo hiểm, KPCĐ ',
};
